import { base44 } from '@/api/base44Client';

const normalizeEmail = (value) => String(value || '').trim().toLowerCase();

export async function getMemberByUser(currentUser) {
  if (!currentUser) return null;

  if (currentUser.id) {
    const byUserId = await base44.entities.Member.filter({ user_id: currentUser.id });
    if (byUserId?.length) return byUserId[0];
  }

  const normalizedUserEmail = normalizeEmail(currentUser.email);
  if (!normalizedUserEmail) return null;

  const byEmail = await base44.entities.Member.filter({ email: normalizedUserEmail });
  if (byEmail?.length) {
    const member = byEmail[0];
    if (!member?.user_id && currentUser.id) {
      try {
        const updated = await base44.entities.Member.update(member.id, { user_id: currentUser.id });
        return updated || member;
      } catch (_error) {
        return member;
      }
    }
    return member;
  }

  const candidates = await base44.entities.Member.list('-created_date', 1000);
  const fallbackMember = candidates.find((member) => normalizeEmail(member?.email) === normalizedUserEmail) || null;
  if (fallbackMember && !fallbackMember.user_id && currentUser.id) {
    try {
      const updated = await base44.entities.Member.update(fallbackMember.id, { user_id: currentUser.id });
      return updated || fallbackMember;
    } catch (_error) {
      return fallbackMember;
    }
  }
  return fallbackMember;
}
